import PropTypes from 'prop-types';
// @mui
import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import DrawerCard from './CellCard';

// ----------------------------------------------------------------------

CellList.propTypes = {
    products: PropTypes.array.isRequired,
};

export default function CellList({
    idPermission,
    idCabinet,

    dataActionRef,
    getData,
    products,
    importWarehouse,
    functDelete,
    setData,
    functEdit,
    typeCabinet,
    screenPermissions,
    ...other
}) {

    if (typeCabinet === 'round') {
        return (
            <>
                <Grid container spacing={4} justifyContent="left" alignItems="center">
                    {products.map((product, index) => (
                        <>
                            {product.map((item, index) => (
                                <Grid key={index} item xs={12} sm={4} md={3} lg={3} xl={3}>
                                    <DrawerCard
                                        navigate={() => functEdit}
                                        getData={getData}
                                        dataActionRef={dataActionRef}
                                        importWarehouse={importWarehouse}
                                        idPermission={idPermission}
                                        functDelete={functDelete}
                                        functEdit={functEdit}
                                        product={item}
                                        setData={setData}
                                        typeCabinet={typeCabinet}
                                        screenPermissions={screenPermissions}
                                    />
                                </Grid>
                            ))}
                        </>
                    ))}
                </Grid>
            </>
        )
    }

    return (
        <TableContainer component={Paper}>
            <Table sx={{ width: '100%' }} aria-label="simple table">
                <TableBody sx={{ backgroundColor: '#f2f3f7' }}>
                    <Grid spacing={0.2} container {...other}>
                        {products.map((product, index) => (
                            <TableRow
                                style={{ backgroundColor: '#f2f3f7' }}
                                key={index}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                {product.map((item, index) => (
                                    <TableCell align="center" key={index}>
                                        <DrawerCard
                                            navigate={() => functEdit}
                                            getData={getData}
                                            dataActionRef={dataActionRef}
                                            importWarehouse={importWarehouse}
                                            idPermission={idPermission}
                                            functDelete={functDelete}
                                            functEdit={functEdit}
                                            product={item}
                                            setData={setData}
                                            typeCabinet={typeCabinet}
                                            screenPermissions={screenPermissions}
                                        />
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </Grid>
                </TableBody>
            </Table>
        </TableContainer>
    );
}
